"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var _diffieHellman = require("diffie-hellman");

var _uuid = require("uuid");

var _hex2dec = require("./hex2dec");

var _store = require("./store");

var _logger = _interopRequireDefault(require("./logger"));

var ENCRYPT_TOKEN_KEY = 'fargo_encrypt_token';
var isNodeEnv = typeof window === 'undefined';

var Encrypt = /*#__PURE__*/function () {
  function Encrypt(_ref) {
    var _ref$fnGetEncryptPara = _ref.fnGetEncryptParams,
        fnGetEncryptParams = _ref$fnGetEncryptPara === void 0 ? Promise.resolve : _ref$fnGetEncryptPara,
        _ref$fnGetEncryptKey = _ref.fnGetEncryptKey,
        fnGetEncryptKey = _ref$fnGetEncryptKey === void 0 ? Promise.resolve : _ref$fnGetEncryptKey,
        encryptIV = _ref.encryptIV;
    (0, _classCallCheck2["default"])(this, Encrypt);
    this.fnGetEncryptParams = fnGetEncryptParams;
    this.fnGetEncryptKey = fnGetEncryptKey;
    this.encryptIV = _cryptoJs["default"].enc.Utf8.parse(encryptIV);
    this.isCreating = false;
    this.createResolves = [];
    this.encryptKey = undefined;
    this.needEncrypt = true;
    this.token = '';
  }

  (0, _createClass2["default"])(Encrypt, [{
    key: "refreshEncryptKey",
    value: function () {
      var _refreshEncryptKey = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(prevReqParams) {
        var _yield$this$fnGetEncr, p, g, god, DH, clientPubKey, encryptToken, _yield$this$fnGetEncr2, serverPublicKey, deServerKey, originKey, tmp;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.fnGetEncryptParams || !this.fnGetEncryptKey)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return this.fnGetEncryptParams(prevReqParams);

              case 4:
                _yield$this$fnGetEncr = _context.sent;
                p = _yield$this$fnGetEncr.p;
                g = _yield$this$fnGetEncr.g;
                god = _yield$this$fnGetEncr.god;

                if (!(!god || god === 0)) {
                  _context.next = 11;
                  break;
                }

                this.needEncrypt = false;
                return _context.abrupt("return");

              case 11:
                DH = (0, _diffieHellman.createDiffieHellman)((0, _hex2dec.decToHex)(p, {
                  prefix: false
                }), 'hex', (0, _hex2dec.decToHex)(g, {
                  prefix: false
                }), 'hex');
                DH.generateKeys();
                clientPubKey = DH.getPublicKey('hex');
                clientPubKey = Buffer.from((0, _hex2dec.hexToDec)(clientPubKey)).toString('base64');
                encryptToken = this.getEncryptToken(true);
                _context.next = 18;
                return this.fnGetEncryptKey({
                  god: god,
                  clientPubKey: clientPubKey,
                  encryptToken: encryptToken
                }, prevReqParams);

              case 18:
                _yield$this$fnGetEncr2 = _context.sent;
                serverPublicKey = _yield$this$fnGetEncr2.serverPublicKey;
                deServerKey = Buffer.from(serverPublicKey, 'base64').toString();

                if (isNodeEnv) {
                  deServerKey = (0, _hex2dec.decToHex)(deServerKey, {
                    prefix: false
                  });
                }

                if (isNodeEnv) {
                  originKey = DH.computeSecret(deServerKey, 'hex');
                } else {
                  originKey = DH.computeSecret(deServerKey);
                }

                tmp = (0, _hex2dec.hexToDec)(originKey.toString('hex')).slice(0, 32);
                (0, _logger["default"])('encrypt key:', tmp);
                this.encryptKey = _cryptoJs["default"].enc.Utf8.parse(tmp);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshEncryptKey(_x) {
        return _refreshEncryptKey.apply(this, arguments);
      }

      return refreshEncryptKey;
    }()
  }, {
    key: "getEncryptToken",
    value: function getEncryptToken() {
      var forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (forceRefresh || !this.token) {
        return this.generateToken();
      }

      return this.token;
    }
  }, {
    key: "generateToken",
    value: function generateToken() {
      this.token = (0, _uuid.v4)();
      return this.token;
    }
  }, {
    key: "encrypt",
    value: function encrypt(word) {
      if (!this.needEncrypt) {
        return word;
      }

      var hexStr = Buffer.from(word).toString('hex');

      var srcs = _cryptoJs["default"].enc.Hex.parse(hexStr);

      var encrypted = _cryptoJs["default"].AES.encrypt(srcs, this.encryptKey, {
        iv: this.encryptIV,
        mode: _cryptoJs["default"].mode.CBC,
        padding: _cryptoJs["default"].pad.Pkcs7
      });

      return encrypted.ciphertext.toString(_cryptoJs["default"].enc.Base64);
    }
  }, {
    key: "decrypt",
    value: function decrypt(word) {
      if (!this.needEncrypt) {
        return word;
      }

      var decrypt = _cryptoJs["default"].AES.decrypt(word, this.encryptKey, {
        iv: this.encryptIV,
        mode: _cryptoJs["default"].mode.CBC,
        padding: _cryptoJs["default"].pad.Pkcs7
      });

      var hex = decrypt.toString(_cryptoJs["default"].enc.Hex);
      var ret = Buffer.from(hex, 'hex');

      if (isNodeEnv) {
        return ret;
      }

      return ret.buffer;
    }
  }]);
  return Encrypt;
}();

var _default = Encrypt;
exports["default"] = _default;